export function animateValue(
  from: number,
  to: number,
  onUpdate: (value: number) => void,
  duration = 900
): number | null {
  if (from === to) {
    onUpdate(to);
    return null;
  }

  const start = performance.now();
  let rafId = 0;

  const step = (now: number): void => {
    const k = Math.min(1, (now - start) / duration);
    const eased = 1 - Math.pow(1 - k, 3);
    onUpdate(from + (to - from) * eased);

    if (k < 1) {
      rafId = requestAnimationFrame(step);
    }
  };

  rafId = requestAnimationFrame(step);
  return rafId;
}
